import Collection from "../../data-structures/collection"
import Event from "./event"

export default class EventsCollectionDepricated extends Collection<Event> {

    constructor(models?:any[]) {
        super(models)
    }

    static initFromJson(data:JSONArray):EventsCollectionDepricated {

        const collection = new EventsCollectionDepricated()

        const models : Event[] = []
        _.map(data, (eventData:JSONObject)=>{
            models.push(new Event(eventData))
        })

        collection.reset(models)

        return collection
    }
}